import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import HowItWorks from '../components/HowItWorks';
import Features from '../components/Features';
import BusinessModel from '../components/BusinessModel';
import Solutions from '../components/Solutions';
import Partners from '../components/Partners';
import Advantages from '../components/Advantages';
import Contact from '../components/Contact';
import CTA from '../components/CTA';
import Footer from '../components/Footer';

const HomePage = () => {
  useEffect(() => {
    // Scroll to hash on load
    if (window.location.hash) {
      const element = document.querySelector(window.location.hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      data-testid="home-page"
    >
      <Navbar />
      <main>
        <Hero />
        <HowItWorks />
        <Features />
        <BusinessModel />
        <Solutions />
        <Partners />
        <Advantages />
        <CTA />
        <Contact />
      </main>
      <Footer />
    </motion.div>
  );
};

export default HomePage;
